/*
* Pipeline Theme — custom JavaScript
*
* This file is imported from layout/theme.liquid. Pipeline ships that import
* COMMENTED OUT, so if zoom (or anything else here) stops working, check there
* first — see the [ATLAS] note next to the <script> tag.
*
* Everything must stay inside the IIFE below so nothing leaks into global scope.
* NOTE: each IIFE needs its OWN closing "})();". A missing one is a SyntaxError
* that silently kills this entire file — no console warning on the page, just
* nothing running.
*/

(function () {
  // ==========================================================================
  // [ATLAS] Make the whole product image clickable to open the PhotoSwipe zoom
  // --------------------------------------------------------------------------
  // Pipeline only opens the lightbox from a small button inside
  // .media__buttons__holder. Customers expect clicking the image itself to
  // zoom, so this forwards a click anywhere on the image to that button.
  // ==========================================================================
  function initImageClickZoom() {
    var wrappers = document.querySelectorAll('.product-image-wrapper:not([data-atlas-zoom])');
    wrappers.forEach(function (wrapper) {
      wrapper.setAttribute('data-atlas-zoom', '1'); // [ATLAS] bind once per wrapper
      wrapper.style.cursor = 'zoom-in';
      wrapper.addEventListener('click', function (e) {
        // [ATLAS] the real zoom button is inside the image — don't double-fire
        if (e.target.closest('.media__buttons__holder')) return;
        // [ATLAS] scope the lookup to THIS slide, not the whole document, or a
        // gallery with several images always opens the first one
        var cell = wrapper.closest('.flickity-cell, .product__media, li');
        var zoomBtn = cell
          ? cell.querySelector('.media__buttons__holder button')
          : wrapper.querySelector('.media__buttons__holder button');
        if (zoomBtn) zoomBtn.click();
      });
    });
  }

  // [ATLAS] Flickity builds the gallery asynchronously, so slides can appear
  // after first paint. Watch for them rather than binding once.
  var zoomObserver = new MutationObserver(function () {
    if (document.querySelector('.product-image-wrapper')) {
      initImageClickZoom();
    }
  });
  zoomObserver.observe(document.body, { childList: true, subtree: true });

  // [ATLAS] This file loads with defer, so DOMContentLoaded normally still
  // fires after it — but guard anyway in case the import is ever moved.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageClickZoom);
  } else {
    initImageClickZoom();
  }

  // [ATLAS] Switching variants swaps the gallery markup
  document.addEventListener('theme:variant:change', function () {
    setTimeout(initImageClickZoom, 300);
  });
})();
